/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../core/store';
import { fetchBrands, selectBrands, selectIsFetching } from '../../store/assessmentsArchiveSlice';
import { Brand } from '../../../../shared/model/brand.model';
import { SelectItem } from '../../../../shared/ModalSelectField';
import { ModalMultiSelectField } from '../../../../shared/ModalMultiSelectField';
import { AssessmentSharedFilter } from '../../model/assessmentFilter.model';
import { convertSharedFilterInAssessmentArchiveFilter } from '../../model/assessmentArchiveQueryParams';

interface BrandMultiSelectFieldProps {
  filters: AssessmentSharedFilter;
  defaultValue?: Brand[];
  editable?: boolean;
  onUpdate?: (brand: Brand[]) => void;
}

export function BrandMultiSelectField({
  filters,
  defaultValue = [],
  editable = false,
  onUpdate,
}: BrandMultiSelectFieldProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (editable) {
      dispatch(fetchBrands(convertSharedFilterInAssessmentArchiveFilter(filters)));
    }
  }, [dispatch, editable, filters]);

  const brandList = useSelector(selectBrands);
  const isFetching = useSelector(selectIsFetching);

  const toSelectItem = (item: Brand): SelectItem => {
    return {
      code: item.code,
      description: item.description,
      logo: item.logo,
    };
  };

  const toBrand = (item: SelectItem): Brand => {
    return {
      code: item.code,
      description: item.description,
      logo: item.logo || '',
    };
  };

  return (
    <ModalMultiSelectField
      icon='copyright'
      loading={isFetching}
      defaultValue={defaultValue != null ? defaultValue.map(v => toSelectItem(v)) : []}
      list={brandList.map((b): SelectItem => toSelectItem(b) as SelectItem)}
      title={t('assessment.archive.filters.brands') || ''}
      editable={editable}
      onUpdateValue={(selectedBrand: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedBrand.map(i => toBrand(i)));
        }
      }}
    />
  );
}
